<template>
  <v-row class="px-4">
    <v-card class="info-card" width="100%">
      <v-card-text>
        <v-row>
          <v-col cols="10">
            <h3 class="info-title">{{ title }}</h3>

            <p class="info-description">{{ description }}</p>
          </v-col>
          <v-col cols="2" class="d-flex flex-row-reverse">
            <p class="status">
              <mf-icon fill small :color="getStatusLabel(status).color">fiber_manual_record</mf-icon><span>{{ getStatusLabel(status).text }}</span>
            </p>
          </v-col>
        </v-row>

        <v-row v-if="messageInfos && messageInfos.length">
          <v-col v-for="(info, index) in messageInfos" :key="index" :cols="info.cols">
            <h3 class="info-header">{{ info.header }}</h3>
            <p class="info-description">{{ info.description }}</p>
          </v-col>
        </v-row>
        <slot>
          <v-row>
            <v-col :cols="colSize">
              <h3 class="info-header">Data e hora de envio</h3>
              <p v-if="date" class="info-description">{{ DateTime.fromFormat(date, 'yyyy-MM-dd').toFormat('dd/MM/yyyy') }} - {{ time }}</p>
            </v-col>
            <v-col :cols="colSize">
              <h3 class="info-header">Frequência de envio</h3>
              <p class="info-description">
                {{ frequencyType === 'RECURRENT' ? `A cada ${frequencyInterval} dias` : `Envio único` }}
              </p>
            </v-col>
            <v-col :cols="colSize">
              <h3 class="info-header">Periodo de mensuração</h3>
              <p v-if="initialDate && finalDate" class="info-description">
                {{ DateTime.fromFormat(initialDate, 'yyyy-MM-dd').toFormat('dd/MM/yyyy') }} -
                {{ DateTime.fromFormat(finalDate, 'yyyy-MM-dd').toFormat('dd/MM/yyyy') }}
              </p>
            </v-col>
            <v-col v-if="industry" cols="3">
              <v-row>
                <h3 class="info-header">Indústria</h3>
                <Tooltip align="right" message="Custos de SMS serão pagos pela Indústria, não descontando do seu saldo atual de créditos">
                  <mf-icon small class="mt-1 mb-1 ml-1" color="cinza-d20">info</mf-icon>
                </Tooltip>
              </v-row>
              <v-row>
                <p class="info-description">
                  {{ industry.name }}
                </p>
              </v-row>
            </v-col>
          </v-row>
          <v-row>
            <v-col :cols="colSize">
              <h3 class="info-header">Segmentos</h3>
              <div v-if="segments && segments.length">
                <v-chip-group :column="showAllSegments" show-arrows active-class="primary--text">
                  <v-chip v-for="(segment, index) in segments" :key="index" small :ripple="false">
                    <span v-if="segment"
                      ><b>{{ segment.name }}</b
                      >{{ segment.clients_qty_at_campaign !== null ? ` (${segment.clients_qty_at_campaign} clientes)` : '' }}</span
                    >
                  </v-chip>
                </v-chip-group>
                <a v-if="segments.length > 1" class="user-select-none mt-3 mb-0 body-2" @click="showAllSegments = !showAllSegments">{{
                  showAllSegments ? 'Minimizar' : 'Mostrar todos'
                }}</a>
              </div>
              <div v-else>
                <p class="info-description">Sem segmentos selecionados</p>
              </div>
            </v-col>
            <v-col cols="8">
              <h3 class="info-header">Produtos</h3>
              <div v-if="products && products.length">
                <v-chip-group :column="showAllProducts" show-arrows active-class="primary--text">
                  <v-chip v-for="(product, index) in products" :key="index" small :ripple="false">
                    <span>{{ product.sku }} - {{ product.name }}</span>
                  </v-chip>
                </v-chip-group>
                <a v-if="products.length > 1" class="user-select-none mt-3 mb-0 body-2" @click="showAllProducts = !showAllProducts">{{
                  showAllProducts ? 'Minimizar' : 'Mostrar todos'
                }}</a>
              </div>
              <div v-else>
                <p class="info-description">Sem produtos selecionados</p>
              </div>
            </v-col>
          </v-row>
        </slot>
      </v-card-text>
    </v-card>
  </v-row>
</template>

<script>
import { DateTime } from 'luxon'
import Tooltip from '@/modules/campanhas/gestao-ofertas-v2/views/components/Tooltip'
import { getStatusLabel } from '@/config/helpers.js'

export default {
  components: {
    Tooltip,
  },
  props: {
    title: String,
    description: String,
    date: String,
    time: String,
    segments: Array,
    products: Array,
    initialDate: String,
    finalDate: String,
    status: String,
    frequencyType: String,
    frequencyInterval: Number,
    messageInfos: Array,
    industry: null,
  },
  data: () => ({
    showAllSegments: false,
    showAllProducts: false,
    DateTime: DateTime,
  }),
  computed: {
    colSize() {
      return this.industry ? 3 : 4
    },
  },
  methods: {
    getStatusLabel,
  },
}
</script>

<style lang="scss">
.status {
  padding-bottom: 4px;
  span {
    font-size: 12px;
    letter-spacing: 0.2px;
  }
}
.info-card {
  .info-title {
    font-size: 20px;
    font-weight: bold;
    letter-spacing: 0.33px;
    margin-bottom: 8px;
    color: $cinza-d20;
  }
  .info-description {
    font-size: 14px;
    letter-spacing: 0.23px;
    color: $cinza-d10;
    margin-bottom: 0;
  }
  .info-header {
    font-size: 18px;
    letter-spacing: 0.33px;
    margin-bottom: 8px;
    color: $cinza-d20;
  }

  .date-box,
  .time-box {
    width: fit-content;
    padding: 2px 12px;
    border-radius: 16px;
    background-color: $cinza-l60;
    font-size: 14px;
    letter-spacing: 0.23px;
    text-align: center;
    color: $cinza-d20;
  }
}
</style>
